import {Component, OnInit} from '@angular/core';
import {
    AgencyInProgressComponentComponent
} from "../agency-etab-missions-details/encour-component/agency-in-progress-component.component";
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {ActivatedRoute, RouterOutlet} from "@angular/router";
import {
  AgencyInProgressMissionForCandidateComponent
} from "./agency-in-progress-mission-for-candidate/agency-in-progress-mission-for-candidate.component";
import {
  AgencyTerminatedMissionForCandidateComponent
} from "./agency-terminated-mission-for-candidate/agency-terminated-mission-for-candidate.component";
import {EstablishmentService} from "../../../services/establishment.service";
import {CandidatService} from "../../../services/candidat.service";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-agency-candidate-missions-details',
  standalone: true,
  imports: [
    AgencyInProgressComponentComponent,
    MatTab,
    MatTabGroup,
    RouterOutlet,
    AgencyInProgressMissionForCandidateComponent,
    AgencyTerminatedMissionForCandidateComponent,
    NgIf
  ],
  templateUrl: './agency-candidate-missions-details.component.html',
  styleUrl: './agency-candidate-missions-details.component.scss'
})
export class AgencyCandidateMissionsDetailsComponent implements OnInit {
  private id: any;
  public name: string;

  constructor(private api: CandidatService,
              private route: ActivatedRoute,
  ) {
    this.id = this.route.snapshot.params['candidatId'] ?? 0;
  }

  ngOnInit(): void {
    if (this.id) {
      this.api.getCandidatFullnameById(this.id).subscribe({
        next: (response) => {
          this.name = response.fullname;
        },
        error: (err) => {
          console.error('Error fetching candidate fullname:', err);
          this.name = 'Unknown';
        }
      });
    }
  }

}
